export default (params) => ({
  trigger: {
    name: 'service_accessory_overlays.close_overlay',
    params: params,
  },
  config: {
    schema: {
      sub_feature: {
        enum: [
          'wall_mount_selector',
          'stacking_kit_overlay',
        ],
      },
    },
    event: {
      name: 'close',
    },
  },
});
